import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTennisLiveTemplateFile } from '../../../selectors/teams';
import AddPlayersTemplateModal from '../AddPlayersTemplateModal';
import { aGetTennisLiveTemplateFileRequest, aSaveTennisLiveTemplateRequest } from '../../../reducers';

const mapToProps = (state) => ({
  liveTemplateFile: getTennisLiveTemplateFile(state),
});
const actionsToProps = (dispatch) => ({
  getLiveTemplateFileRequest: (payload) => dispatch(aGetTennisLiveTemplateFileRequest(payload)),
  saveLiveTemplate: (payload) => dispatch(aSaveTennisLiveTemplateRequest(payload)),
});
class AddLiveTemplateSection extends Component {
  componentDidMount() {
    this.props.getLiveTemplateFileRequest();
  }

  render() {
    return (
      <AddPlayersTemplateModal
        playersTemplateFile={this.props.liveTemplateFile}
        applyPlayersTemplatePreview={this.props.saveLiveTemplate}
        leagues={this.props.leagues}
        setOpenModal={this.props.setOpenModal}
        activeModal={this.props.activeModal}
        closeModal={this.props.closeModal}
        titleName="New Live Template"
        selectDescription="Select the competition to apply live template"
        saveBtnLabel="Save"
      />
    );
  }
}
export default connect(mapToProps, actionsToProps)(AddLiveTemplateSection);
